export const setupTemaDelDia = () => {
  let elementos = document.querySelectorAll(".postheader__tema_del_dia");

  if (elementos && elementos.length > 2) {
    setInterval(() => {
      let elemento_actual;

      if (window.screen.width > 970) {
        elemento_actual = document.querySelector(
          ".postheader.desktop .postheader__tema_del_dia.active"
        );
      } else {
        elemento_actual = document.querySelector(
          ".postheader.mobile .postheader__tema_del_dia.active"
        );
      }

      let intervalo_principal = setInterval(function () {
        let curr_opacity = getComputedStyle(elemento_actual).opacity;
        curr_opacity = Math.round(curr_opacity * 10) / 10;
        let nueva_opacity = parseFloat(curr_opacity) - 0.9;
        elemento_actual.style.opacity = nueva_opacity;

        if (elemento_actual.style.opacity < 0) {
          clearInterval(intervalo_principal);
          setTimeout(() => {
            elemento_actual.style.display = "none";
            elemento_actual.classList.remove("active");
            let siguiente = elemento_actual.nextElementSibling;
            if (!siguiente)
              if (window.screen.width > 970) {
                siguiente = document.querySelectorAll(
                  ".postheader .postheader__tema_del_dia"
                )[0];
              } else {
                siguiente = document.querySelector(
                  ".postheader.mobile .postheader__tema_del_dia"
                );
              }
            siguiente.classList.add("active");
            siguiente.style.opacity = 0;
            siguiente.style.display = "inline";
            let intervalo_siguiente = setInterval(function () {
              siguiente.style.opacity =
                parseFloat(getComputedStyle(siguiente).opacity) + 0.9;
              if (siguiente.style.opacity > 0.99) {
                clearInterval(intervalo_siguiente);
                siguiente.style.opacity = 1;
              }
            }, 100);
          }, 110);
        }
      }, 100);
    }, 7000);
  }
};
